import makeRequest from './makeRequest';
import environment from '../environment';
import { showExpressError } from '../util/errorPopupUtil';

export const fetchPartnerTags = async (params) => {
  return await makeRequest(`${environment.app.serverApiUrl}/v1/tags/getPartnerTags`, {
    params,
  });
};

export const updatePartnerTags = async (ticket, tags, formId) => {
  const payload = {
    tags,
    formId,
    ticketId: ticket.ticketId,
  };

  try {
    await makeRequest(`${environment.app.serverApiUrl}/v1/tags/setPartnerTags`, {
      method: 'post',
      data: payload,
    });
  } catch (error) {
    showExpressError(error, 'Unable to update partner tags');
  }
};

export const isAutoTaggingAvailable = async (ticket, simplrTag) => {
  const payload = {
    simplrTag,
    ticketId: ticket.ticketId,
  };

  // NOTE(vlad|SPD-15333|2026-07-31): POST+body instead of GET+query so free-text simplrTag
  // (may contain "--") stays out of the query string where CloudFront WAF SQLi rule 403-blocks it.
  return await makeRequest(`${environment.app.serverApiUrl}/v1/tags/isAutoTaggingAvailable`, {
    method: 'post',
    data: payload,
  });
};

export const setAutoTags = async (ticket, simplrTag) => {
  const payload = {
    simplrTag,
    ticketId: ticket.ticketId,
  };

  return await makeRequest(`${environment.app.serverApiUrl}/v1/tags/setAutoTags`, {
    method: 'post',
    data: payload,
  });
};
